/* ============================================================
   PIANKOMAT — theme.js (vanilla, bez zależności)
   ============================================================ */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) =>
    (cents / 100).toLocaleString('pl-PL', { style: 'currency', currency: window.Shopify?.currency?.active || 'PLN' });

  /* ---------- Header: cień po scrollu ---------- */
  const header = $('.header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Mobile nav ---------- */
  const mobileNav = $('.mobile-nav');
  $$('[data-open-nav]').forEach((b) => b.addEventListener('click', () => toggle(mobileNav, true)));
  if (mobileNav) {
    $('.mobile-nav__overlay', mobileNav)?.addEventListener('click', () => toggle(mobileNav, false));
    $$('[data-close-nav]', mobileNav).forEach((b) => b.addEventListener('click', () => toggle(mobileNav, false)));
  }

  /* ---------- Dropdown menu w nagłówku (klik na dotyku/klawiaturze) ---------- */
  $$('.header__dropdown').forEach((dd) => {
    const trigger = $('.header__dropdown-trigger', dd);
    trigger?.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = !dd.classList.contains('is-open');
      $$('.header__dropdown.is-open').forEach((o) => { if (o !== dd) { o.classList.remove('is-open'); $('.header__dropdown-trigger', o)?.setAttribute('aria-expanded', 'false'); } });
      dd.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', String(open));
    });
  });
  document.addEventListener('click', () => {
    $$('.header__dropdown.is-open').forEach((dd) => { dd.classList.remove('is-open'); $('.header__dropdown-trigger', dd)?.setAttribute('aria-expanded', 'false'); });
  });

  /* ---------- Panel filtrów kolekcji ---------- */
  const filtersPanel = $('[data-filters-panel]');
  const toggleFilters = (open) => {
    if (!filtersPanel) return;
    filtersPanel.setAttribute('aria-hidden', String(!open));
    document.body.style.overflow = open ? 'hidden' : '';
  };
  $$('[data-open-filters]').forEach((b) => b.addEventListener('click', () => toggleFilters(true)));
  $$('[data-close-filters]', filtersPanel || document).forEach((b) => b.addEventListener('click', () => toggleFilters(false)));

  /* ---------- Reveal on scroll ---------- */
  const reveals = $$('[data-reveal]');
  if (reveals.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }),
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- Galeria produktu (zdjęcia / wideo / 3D) ---------- */
  $$('[data-gallery]').forEach((gallery) => {
    const stage = $('[data-stage]', gallery);
    $$('[data-thumb]', gallery).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        $$('[data-thumb]', gallery).forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        stage.innerHTML = thumb.dataset.media;
        // odpal wideo jeśli weszło na scenę
        const v = $('video', stage); if (v) { v.muted = true; v.play().catch(() => {}); }
      });
    });
  });

  /* ---------- Ilość +/- ---------- */
  $$('[data-qty]').forEach((wrap) => {
    const input = $('input', wrap);
    $('[data-qty-minus]', wrap)?.addEventListener('click', () => { input.value = Math.max(1, (+input.value || 1) - 1); input.dispatchEvent(new Event('change')); });
    $('[data-qty-plus]', wrap)?.addEventListener('click', () => { input.value = (+input.value || 1) + 1; input.dispatchEvent(new Event('change')); });
  });

  /* ---------- Wybór wariantu ---------- */
  $$('[data-product-form]').forEach((form) => {
    const data = safeJSON($('[data-variants]', form)?.textContent);
    if (!data) return;
    const idField = $('[name="id"]', form);
    const priceEl = $('[data-price-current]', form);
    const compareEl = $('[data-price-compare]', form);
    const atc = $('[data-atc]', form);

    const update = () => {
      const chosen = $$('[data-product-option]:checked', form).map((i) => i.value);
      const variant = data.find((v) => v.options.every((o, idx) => o === chosen[idx])) || data[0];
      if (!variant) return;
      idField.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) compareEl.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
      if (atc) {
        atc.disabled = !variant.available;
        atc.textContent = variant.available ? atc.dataset.label : 'Wyprzedane';
      }
      $$('[data-sticky-price]').forEach((s) => (s.textContent = money(variant.price)));
    };
    $$('[data-product-option]', form).forEach((i) => i.addEventListener('change', update));
    update();
  });

  /* ---------- Koszyk AJAX + drawer ---------- */
  const drawer = $('.cart-drawer');
  const openDrawer = () => toggle(drawer, true);
  $$('[data-open-cart]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  if (drawer) {
    $('.cart-drawer__overlay', drawer)?.addEventListener('click', () => toggle(drawer, false));
    $$('[data-close-cart]', drawer).forEach((b) => b.addEventListener('click', () => toggle(drawer, false)));
  }

  // Dodawanie do koszyka
  $$('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const atc = $('[data-atc]', form);
      const original = atc?.textContent;
      if (atc) { atc.disabled = true; atc.textContent = 'Dodaję...'; }
      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
        if (!res.ok) throw new Error('add failed');
        await refreshCart();
        openDrawer();
      } catch (err) {
        if (atc) atc.textContent = 'Spróbuj ponownie';
      } finally {
        if (atc) { atc.disabled = false; setTimeout(() => (atc.textContent = original), 1200); }
      }
    });
  });

  async function refreshCart() {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      renderCart(cart);
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    } catch (e) {}
  }

  function renderCart(cart) {
    if (!drawer) return;
    const itemsEl = $('.cart-drawer__items', drawer);
    const footEl = $('.cart-drawer__foot', drawer);
    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="cart-empty"><p>Twój koszyk jest pusty</p><button class="button button--ghost" data-close-cart>Kontynuuj zakupy</button></div>';
      footEl.hidden = true;
      $('[data-close-cart]', itemsEl)?.addEventListener('click', () => toggle(drawer, false));
      return;
    }
    footEl.hidden = false;
    itemsEl.innerHTML = cart.items.map((it) => `
      <div class="cart-item" data-key="${it.key}">
        <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') : ''}" alt="">
        <div>
          <div class="ci-title">${it.product_title}</div>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="text-muted" style="font-size:.85rem">${it.variant_title}</div>` : ''}
          <div class="qty" data-qty style="margin-top:8px;transform:scale(.82);transform-origin:left">
            <button type="button" data-line-minus>–</button>
            <input value="${it.quantity}" inputmode="numeric" readonly>
            <button type="button" data-line-plus>+</button>
          </div>
        </div>
        <div style="text-align:right">
          <div class="ci-price">${money(it.final_line_price)}</div>
          <button class="text-muted" style="background:none;border:none;font-size:.82rem;text-decoration:underline;margin-top:8px" data-line-remove>Usuń</button>
        </div>
      </div>`).join('');

    // próg darmowej wysyłki
    const threshold = parseInt(footEl.dataset.shipThreshold || '0', 10);
    const bar = $('.ship-bar span', footEl);
    const msg = $('[data-ship-msg]', footEl);
    if (threshold > 0 && bar) {
      const pct = Math.min(100, (cart.total_price / threshold) * 100);
      bar.style.width = pct + '%';
      if (msg) msg.textContent = cart.total_price >= threshold
        ? 'Masz darmową dostawę! 🎉'
        : `Dodaj jeszcze ${money(threshold - cart.total_price)} do darmowej dostawy`;
    }
    $('[data-cart-total]', footEl).textContent = money(cart.total_price);

    // akcje na liniach
    $$('.cart-item', itemsEl).forEach((row) => {
      const key = row.dataset.key;
      const input = $('input', row);
      $('[data-line-minus]', row)?.addEventListener('click', () => changeLine(key, Math.max(0, (+input.value) - 1)));
      $('[data-line-plus]', row)?.addEventListener('click', () => changeLine(key, (+input.value) + 1));
      $('[data-line-remove]', row)?.addEventListener('click', () => changeLine(key, 0));
    });
  }

  async function changeLine(key, qty) {
    try {
      const cart = await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      }).then((r) => r.json());
      renderCart(cart);
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    } catch (e) {}
  }
  refreshCart();

  /* ---------- Sticky add-to-cart (mobile) ---------- */
  const sticky = $('.sticky-atc');
  const mainAtc = $('[data-atc]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      ([e]) => sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0),
      { threshold: 0 }
    );
    io.observe(mainAtc);
    $('[data-sticky-buy]', sticky)?.addEventListener('click', () => mainAtc.closest('form')?.requestSubmit());
  }

  /* ---------- helpers ---------- */
  function toggle(el, open) {
    if (!el) return;
    el.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  function safeJSON(t) { try { return JSON.parse(t); } catch (e) { return null; } }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      [drawer, mobileNav].forEach((el) => el && toggle(el, false));
      toggleFilters(false);
      $$('.header__dropdown.is-open').forEach((dd) => dd.classList.remove('is-open'));
    }
  });
})();
